/**
 * Clip Detail Sheet for Activity Feed
 *
 * Right-side sheet that shows clip details when clicking "View Clip" in activity details.
 * Allows users to view clip info without leaving the activity feed context.
 */

import { EntityDetailSheet } from '@/components/shared/EntityDetailSheet'
import { ClipDetailContent } from '@/components/clips/ClipDetailContent'
import type { Clip } from '@/types/database'

interface ClipDetailSheetProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  clipId: string | null
  projectId: string
  availableClips?: Clip[]
}

export function ClipDetailSheet({
  open,
  onOpenChange,
  clipId,
  projectId,
  availableClips = []
}: ClipDetailSheetProps) {
  if (!clipId) return null

  return (
    <EntityDetailSheet
      open={open}
      onOpenChange={onOpenChange}
      title="Clip Details"
      width="xl"
    >
      <ClipDetailContent
        clipId={clipId}
        projectId={projectId}
        availableClips={availableClips}
      />
    </EntityDetailSheet>
  )
}
